<template>
  <form autocomplete="off">
    <input-text
      v-for="textInput in textInputs"
      :value="userCredentials[textInput.fieldID]"
      @input="setUserCredential($event, textInput.fieldID)"
      :maxlength="textInput.validation.maxLength"
      :minlength="textInput.validation.minLength"
      :type="textInput.type"
      :id="textInput.fieldID"
      :key="textInput.name"
      :placeholder="getPlaceholder(textInput.fieldID, textInput.name)"
      :strict-mode="{ regex: getRegExp(textInput.validation.chars), skipDefault: true }"
      v-validation="getValidationRules(textInput.optional)"
    >
      <template #label>
        {{ textInput.name }}
      </template>
    </input-text>

    <input-select
      v-for="selectInput in selectInputs"
      :value="userCredentials[selectInput.fieldID]"
      @change="setUserCredential($event, selectInput.fieldID)"
      :options="selectInputOptions(selectInput.values)"
      :id="selectInput.fieldID"
      :key="selectInput.name"
      v-validation:closed="['required']"
    >
      <template #label>{{ selectInput.name }}</template>
    </input-select>

    <slot name="illion-flow-consents" />

    <slot name="error-banner" />
  </form>
</template>
<script>
const placeholderFields = ['username', 'password'];
export default {
  name: 'ProfileConnection',
  props: {
    credentials: {
      type: Array,
      default: () => [],
    },
    userCredentials: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    textInputs() {
      return this.credentials.filter(credential => {
        const type = credential.type.toLowerCase();

        return type === 'text' || type === 'password';
      });
    },
    selectInputs() {
      return this.credentials.filter(credential => {
        const type = credential.type.toLowerCase();

        return type === 'select';
      });
    },
  },
  methods: {
    setUserCredential(event, fieldID) {
      const updatedCredentials = { ...this.userCredentials };
      updatedCredentials[fieldID] = event;

      this.$emit('userCredentialInput', updatedCredentials);
    },
    selectInputOptions(values) {
      const options = [];
      const entries = Object.entries(values);
      entries.forEach(element => options.push({ key: element[0], value: element[1] }));

      return options;
    },
    getPlaceholder(fieldID, name) {
      if (!placeholderFields.includes(fieldID) || !name) return '';
      const placeholder = this.$t(`illion.placeholder.${fieldID}`);
      return `${placeholder} ${name}`;
    },
    getRegExp(validation) {
      if (!validation || validation === '*') return /[^\s\S]/g;
      const regexp = `[^${validation}]`;
      return new RegExp(regexp, 'g');
    },
    getValidationRules(isOptional) {
      return isOptional ? [] : ['required'];
    },
  },
};
</script>
